import { Screen } from '~/screens/clients/[clientId]/client-contracts/[termId]';

export const ClientContractTermDetailIndex = () => <Screen />;
